<template>
  <button @mouseenter="setTooltip()" @mouseleave="setTooltip()" class="btn btn-icon waves-effect btn-default waves-light" @click="flipY()"> <i class="icon-flip-vertical"></i> </button>
</template>

<script>
export default {
    name: 'flipy',
    props: {
    },
    methods: {
        flipY: function () {
            this.$emit('flipY')
        },
        setTooltip: function () {
            this.$emit('tooltip')
        }
    }
}
</script>



// WEBPACK FOOTER //
// flipy.vue?55305394